import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	type JSM_ORGANIZATION_GQL_FIELD,
	ORGANIZATIONS_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

export const transformAggJSMOrganizationToLegacyField: AggTransformerFunction<
	typeof JSM_ORGANIZATION_GQL_FIELD
> = (node) => {
	if (node.type !== ORGANIZATIONS_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformAggConnection(node.selectedOrganizationsConnection, (selectedNode) => ({
			id: selectedNode.organizationId,
			name: selectedNode.organizationName,
		})),
		schema: {
			configuration: null,
			custom: ORGANIZATIONS_CF_TYPE,
			items: 'sd-customerorganization',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
